/* Diamond production details: catalogue measurements remain measurements;
   image counts are estimates, never scaled by the length of a different name. */
(function () {
  'use strict';
  var seed = document.getElementById('segal-diamond-product');
  if (!seed) return;
  var product;
  try { product = JSON.parse(seed.textContent); } catch (_) { return; }
  if (product.type !== 'Diamond Name Necklace') return;
  var doc = new DOMParser().parseFromString(product.description || '', 'text/html');
  var spec = doc.querySelector('[data-segal-diamond-spec]');
  var text = doc.body.textContent.replace(/\s+/g, ' ');
  var sample = String(product.title).replace(/^Diamond Gold Name Necklace\s*[-–—]\s*/i, '').split('|')[0].trim();
  var countMatch = text.match(/(\d+)\s+(?:Natural|Lab[- ]?created)?\s*Diamonds?/i);
  var caratMatch = text.match(/([\d.]+)\s*Carat weight/i);
  var count = spec ? Number(spec.getAttribute('data-stone-count')) : countMatch ? Number(countMatch[1]) : null;
  if (!Number.isInteger(count) || count <= 0) count = null;
  var perStone = 0.00375;
  var total = spec ? count && count * perStone : caratMatch ? Number(caratMatch[1]) : null;
  var source = spec ? spec.getAttribute('data-count-source') : 'existing-catalogue';
  function key(value) { return String(value || '').replace(/[^A-Za-z]/g, '').toLowerCase(); }
  function hidden(form, name, value) {
    var fieldName = 'properties[_' + name + ']';
    var input = Array.prototype.find.call(form.elements, function (el) { return el.name === fieldName; });
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden'; input.name = fieldName;
      input.setAttribute('data-segal-dnn', name); form.appendChild(input);
    }
    if (input.value !== value) input.value = value;
  }
  function update() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var nameInput = form.querySelector('[name="properties[Custom Name]"]');
      var name = nameInput && nameInput.value.trim() || sample;
      var sameName = key(name) === key(sample);
      hidden(form, 'Diamond standard', 'Natural round brilliant; G/H color; SI clarity; Very Good cut; same stone size as Anastasia master');
      hidden(form, 'Diamond carat per stone', 'Approximately 0.00375 ct (nominal catalogue-derived weight)');
      hidden(form, 'Letter height', 'Capital letter: 8 mm / 0.31 in');
      hidden(form, 'Metal setting', 'Match existing Anastasia master metal width and depth to the same uniform stone seats; single-row bead-set pave');
      hidden(form, 'Production review', 'Before casting or setting: confirm stone count, total carat and metal thickness in final CAD for ' + name);
      hidden(form, 'Stone spec source', source + '; product ' + product.id + '; sample ' + sample);
      if (sameName && count && total) {
        hidden(form, 'Stone estimate', (spec ? 'Image estimate: approximately ' : 'Existing catalogue: ') + count + ' diamonds / ' + total.toFixed(2) + ' ct for ' + name + (spec ? '; count x 0.00375 ct; confirm in CAD' : '; published total'));
      } else {
        hidden(form, 'Stone estimate', 'Count pending final CAD for ' + name + '; total ct = confirmed stone count x 0.00375. Do not scale a different name by letter count.');
      }
    });
  }
  document.addEventListener('submit', update, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('button, input[type="submit"]')) update();
  }, true);
  document.addEventListener('input', update, true);
  // The chain app inserts fields after load. Capture values before its Ajax cart handler.
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
  update();
})();
